import { createSlice } from "@reduxjs/toolkit"

export interface AcquisitionSchedule {
  contractExecution: String,
  dueDiligenceEnds: String,
  settlement: String,
}

const initialState: AcquisitionSchedule = {
    contractExecution: "",
    dueDiligenceEnds: "",
    settlement: "",
}

export const AcquisitionScheduleSlice = createSlice({
  name: 'acquisitionScheduleSliceInfo',
  initialState,
  reducers: {
    setAcquisitionSchedule(state, { payload }) {
      return {
        ...state,
        ...payload
      }
    }
  }
})

export const { setAcquisitionSchedule } = AcquisitionScheduleSlice.actions

export default AcquisitionScheduleSlice.reducer
